import { SAVERS } from "../actions/types";

const initalState = { info: {}, saversCount: "0", savers: [] };
const saversReducer = (state = initalState, action) => {
  switch (action.type) {
    case SAVERS.CREATE_SUCCESS:
      const saverCreated = true;
      return { ...state, saverCreated };

    case SAVERS.CREATE_FAIL:
      return state;

    case SAVERS.WITHDRAW_SUCCESS:
      return state;

    case SAVERS.WITHDRAW_FAIL:
      return state;
    case SAVERS.VIEW_SUCCESS:
      const saverInfo = action.payload;

      return { ...state, saverInfo };

    case SAVERS.VIEW_FAIL:
      return { ...state, saverInfo: null };

    case SAVERS.DEPOSIT_SUCCESS:
      return state;

    case SAVERS.DEPOSIT_FAIL:
      return state;

    case SAVERS.COUNT_SUCCESS:
      return { ...state, saversCount: action.payload };

    case SAVERS.CREATE_GOAL_SUCCESS:
      return { ...state, goalCreated: true };

    case SAVERS.CLEAR:
      return {};

    case SAVERS.SAVE_INFO:
      return { ...state, info: action.payload };

    case SAVERS.CLEAR_INFO:
      return { ...state, info: "" };

    case SAVERS.VIEW_SAVERS_SECCESS:
      return { ...state, savers: action.payload };
    default:
      return state;
  }
};

export default saversReducer;
